<template>
    <div :class="classes">
        <header class="layout-heading-tabs__header">
            <div class="layout-heading-tabs__container">
                <h1 class="typographies-heading-h1 layout-heading-tabs__title">
                    {{ title }}
                </h1>
                <HeadingTabs :tabs="tabs" :isOnBackgroundApp="isOnBackgroundApp" />
            </div>
            <div class="layout-heading-tabs__actions">
                <slot name="actions"></slot>
            </div>
        </header>
        <section class="layout-heading-tabs__content">
            <slot></slot>
        </section>
    </div>
</template>

<script>
import HeadingTabs from 'vcomponents/common/HeadingTabs/HeadingTabs.vue';

export default {
    components: {
        HeadingTabs,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
        defaultTab: {
            type: String,
            default: null,
        },
        isResponsiveCentered: {
            type: Boolean,
            default: false,
        },
        isOnBackgroundApp: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            return {
                'layout-heading-tabs': true,
                'layout-heading-tabs--centered': this.isResponsiveCentered,
            };
        },
    },
    watch: {
        defaultTab: {
            immediate: true,
            handler(newTab) {
                if (newTab) {
                    this.navigateToTab(newTab);
                }
            },
        },
    },
    methods: {
        navigateToTab(tabName) {
            const targetTab = this.tabs.find((tab) => tab.name === tabName) || this.tabs[0];
            if (targetTab && this.$route.name !== targetTab.name) {
                this.$router.push({ name: targetTab.name });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.layout-heading-tabs {
    &--centered {
        @media (min-width: 1439px) {
            max-width: 1439px;
            margin: 0 auto;
        }
    }
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 var(--spacing-3);
    }

    &__title {
        margin: 0 var(--spacing-3) 0 0;
    }

    &__container {
        display: flex;
        align-items: center;
    }

    &__actions {
        display: flex;
        gap: var(--spacing-2);
    }

    &__content {
        min-width: 0;
    }
}
</style>
